module.exports = __webpack_public_path__ + "static/ravr-bae20b4a653e4384945e8708c8ea95f1.png";